// forces the babel to analyze this code
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import './reactDomShim'; // React 19 compatibility for legacy libraries
import { composeWithDevTools } from '@redux-devtools/extension';
import { applyMiddleware, createStore } from 'redux';
import { Provider } from 'react-redux';
import { LocalizeProvider } from 'react-localize-redux';
import createSagaMiddleware from 'redux-saga';
import { routerMiddleware } from 'react-router-redux';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { AllEnterpriseModule, LicenseManager, ModuleRegistry } from 'ag-grid-enterprise';
import { HashRouter } from 'react-router-dom';
import browserHistory from './hashHistory';
import GeneralErrorDialogContainer from './appLoadingState/generalErrorDialogContainer';
import GoBackPanel from './topPanels/goBackPanel/goBackPanelContainer';
import TrialStatusPanel from './topPanels/trialStatusPanel/trialStatusPanelContainer';
import Router from './router';
import Topbar from './topbar/Topbar';
import reducers from './reducers';
import init from './utils/init';
import { BACK_PANEL_CONTAINER_CSS_CLASS } from './topPanels/consts';
import CreativeIQTrialPanel from './topPanels/creativeIQTrialPanel/CreativeIQTrialPanel';

ModuleRegistry.registerModules([AllEnterpriseModule]);

LicenseManager.setLicenseKey(
    'Using_this_{AG_Grid}_Enterprise_key_{AG-090952}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Singular_Labs,_Inc.}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Singular_Labs,_Inc.}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{Singular_Labs,_Inc.}_need_to_be_licensed___{Singular_Labs,_Inc.}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{4_July_2026}____[v3]_[01]_MTc4MzExOTYwMDAwMA==8b5f9c3f5efedcf79d79d571843d37c5'
);

// middleware for the redux devtools
const composeEnhancers = composeWithDevTools;
const sagaMiddleware = createSagaMiddleware({
    onError: error => {
        console.log(error);
        if (window.Sentry) {
            window.Sentry.captureException(error);
        }
    },
});
const rMiddleware = routerMiddleware(browserHistory);
const middleWares = [sagaMiddleware, rMiddleware];
const store = createStore(reducers, composeEnhancers(applyMiddleware(...middleWares)));

const loggedInUser = window.impersonationUsername || window.realUsername;
const goBackContainer = document.getElementById(BACK_PANEL_CONTAINER_CSS_CLASS);
const shouldShowGoBackPanel = !!loggedInUser && !!goBackContainer;

let root = null;

const renderApp = RootComponent => {
    const container = document.getElementById('reactContainer');

    if (!root) root = createRoot(container);

    root.render(
        <Provider store={store}>
            <LocalizeProvider store={store}>
                <GeneralErrorDialogContainer />
                {shouldShowGoBackPanel && <GoBackPanel goBackContainer={goBackContainer} />}
                <TrialStatusPanel />
                <Topbar />
                <HashRouter>
                    <CreativeIQTrialPanel />
                    <RootComponent store={store} />
                </HashRouter>
            </LocalizeProvider>
        </Provider>
    );
};

const initApp = () => {
    return init(store, sagaMiddleware);
};

if (initApp()) {
    renderApp(Router);
}

if (module.hot) {
    // hot-module's gonna intercept the files connected (via imports) to the changed files.
    // in case there's no rule defined for any of the files -> FULL RELOAD

    // In case a change was made, connected to the router
    // (which is connect, in turn, to every component) -> reload the components
    module.hot.accept(['./router.jsx', './utils/init.js'], () => {
        const NextRoot = require('./router').default; // eslint-disable-line global-require
        renderApp(NextRoot);
    });

    // In case a change was made, connected to the reducers -> reload the reducers, and hot replace it.
    module.hot.accept('./reducers', () => {
        const newReducers = require('./reducers').default; // eslint-disable-line global-require
        store.replaceReducer(newReducers);
    });
}

window.addEventListener('reactContainerReady', () => {
    if (initApp()) {
        renderApp(Router);
    }
});
